import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentQuestionIndex: 0,
  answers: {},
  reportUrl: 'initial',
  loading: false,
  error: null,
  isComplete: false,
  submissionId: null
};

const quizSlice = createSlice({
    name: 'quiz',
    initialState,
    reducers: {
      setAnswer: (state, action) => {
        const { key, value } = action.payload;
        state.answers[key] = value;
        // Auto-save to localStorage
        localStorage.setItem('quiz_answers', JSON.stringify(state.answers));
        localStorage.setItem('quiz_progress', state.currentQuestionIndex.toString());
      },
      nextQuestion: (state) => {
        state.currentQuestionIndex += 1;
        localStorage.setItem('quiz_progress', state.currentQuestionIndex.toString());
      },
      previousQuestion: (state) => {
        if (state.currentQuestionIndex > 0) {
          state.currentQuestionIndex -= 1;
          localStorage.setItem('quiz_progress', state.currentQuestionIndex.toString());
        }
      },
      loadSavedProgress: (state) => {
        const savedAnswers = localStorage.getItem('quiz_answers');
        const savedProgress = localStorage.getItem('quiz_progress');
        
        if (savedAnswers) {
          state.answers = JSON.parse(savedAnswers);
        }
        if (savedProgress) {
          state.currentQuestionIndex = parseInt(savedProgress);
        }
      },
      // Keep only these submit-related reducers:
      submitQuizStart: (state) => {
        state.loading = true;
        state.error = null;
      },
      submitQuizSuccess: (state, action) => {
        console.log(action);
        state.loading = false;
        state.isComplete = true;
        state.reportUrl = action.payload.reportUrl;
        // // Clear saved progress after successful submission
        localStorage.removeItem('quiz_answers');
        localStorage.removeItem('quiz_progress');
      },
      submitQuizFailure: (state, action) => {
        state.loading = false;
        state.error = action.payload;
      },
      clearQuizData: (state) => {
        localStorage.removeItem('quiz_answers');
        localStorage.removeItem('quiz_progress');
        return { ...initialState };
      }
    }
  });
  
export const {
  setAnswer,
  nextQuestion,
  previousQuestion,
  loadSavedProgress,
  submitQuizStart,
  submitQuizSuccess,
  submitQuizFailure,
  clearQuizData
} = quizSlice.actions;

export default quizSlice.reducer;